import { controls, currencyToNumber, grouped } from "../../controls";

const rpcf30 = {
  label: "Generate FLTRN",
  starting: true,
  url: "rp101m",
  pageLabel: "Generate FLTRN",
  pageType: "history",
  // visitingBranches: true,
  // filteraction: true,
  filter: [
    // ...controls.displayText({ tab: "general", label: "Taluka", star: true }),
    // ...controls.oc({ tab: "general", c: "Taluka", clearData: ['village_code'], placeHolder: "Taluka Code", name: "taluka_code", fastpath: "talukas" }),
    // ...controls.showData({ tab: "general", displaytype: "capital", data: "taluka_display" }),

    // ...controls.displayText({ tab: "general", label: "Village", star: true }),
    // ...controls.oc({ tab: "general", c: "Village", sendToServer: { sendData: [{ varname: 'taluka.taluka_uid', value: 'taluka_uid' }] }, placeHolder: "Village Code", name: "village_code", fastpath: "villages" }),
    // ...controls.showData({ tab: "general", displaytype: "capital", data: "village_display" }),


    ...controls.displayText({ tab: "general", label: "Taluka" }),
    ...controls.oc({ tab: "general", c: "Taluka", placeHolder: "Taluka Code", name: "taluka_code", fastpath: "talukas" }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "taluka_display" }),


    ...controls.displayText({ tab: "general", label: "Talathi" }),
    ...controls.oc({ tab: "general", c: "User", placeHolder: "Talathi Code", name: "user_code", fastpath: "users" }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "user_display" }),

  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Generate FLTRN",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    csvprops: { quotes: false },

    displayColumns: [
      {
        Header: "GLCODE",
        accessor: "GLCODE",
        rwidth: "*"
      },
      {
        Header: "PRCODE",
        accessor: "PRCODE"
      },
      {
        Header: "ACC_NO",
        accessor: "ACC_NO"
      },
      {
        Header: "DRAMT",
        accessor: "DRAMT"
      },
      {
        Header: "CRAMT",
        accessor: "CRAMT"
      },
      {
        Header: "BRCODE",
        accessor: "BRCODE"
      },
      {
        Header: "PARTICULAR",
        accessor: "PARTICULAR"
      }
    ]
  }
};

export default rpcf30;